import type { ENUM_DELIVERY_TYPE } from '@/_features/deliveries/constants';
import { TRANSLATE_DELIVERY_TYPE } from '@/_features/deliveries/constants';
import { Tag } from './components/tag/tag';
import styles from './delivery-tags.module.scss';

interface DeliveryTagsProps {
  deliveryType?: ENUM_DELIVERY_TYPE;
  isNew?: boolean;
  isManual?: boolean;
}

export function DeliveryTags({
  deliveryType,
  isNew,
  isManual,
}: DeliveryTagsProps) {
  const deliveryTypeLabel =
    deliveryType && TRANSLATE_DELIVERY_TYPE[deliveryType];

  if (!deliveryTypeLabel && !isNew && !isManual) {
    return null;
  }

  return (
    <div className={styles.tags}>
      {deliveryTypeLabel && <Tag>{deliveryTypeLabel}</Tag>}
      {isNew && <Tag highlight>Novo</Tag>}
      {isManual && <Tag>Manual</Tag>}
    </div>
  );
}
